import React, { useState } from "react";
import useOtpHook from "../Hooks/useOtpHook";
import { Button, Modal } from "antd";
import { MemberProfile, verifyOtp } from "../ApiServices/Apifun";
import { useNavigate } from "react-router-dom";
import { dispatchtoast } from "../Utils";
import { useDispatch } from "react-redux";
import { setProfile } from "../Store/B2bslice";

const VerifyModal = ({
  isOpen,
  setIsOpen,
  otherFields,
  endpoint,
  apicall = ()=>{},
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const { handleChange, handleKeyUp, pin, inputRefs } = useOtpHook(6);

  const handleVerify = () => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("otp", pin.join(""));
    if (otherFields) {
      Object.entries(otherFields).map(([key, value]) =>
        formdata.append(key, value)
      );
    }
    verifyOtp(formdata, "", endpoint)
      .then((res) => {
        console.log({res})
        if (res.status) {
          setIsOpen(false);
          apicall();
          dispatchtoast(res.message)
          navigate("/dmt/remitters",{state:{allow:true}});
          MemberProfile()
          .then((res) => {
            if (res.status) {
              dispatch(setProfile(res.data.profile));
            } else {
              dispatchtoast("Unable to fetch profile detail", true);
            }
          })
          .catch((err) => console.log(err, "errr"));
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  return (
    <Modal
      title={"Verify OTP"}
      footer={null}
      className="shadow-normal"
      width={300}
      maskClosable={false}
      open={isOpen}
      onCancel={() => setIsOpen(false)}
    >
      <div className="  rounded-3xl shadow-normal bg-white p-5">
        <div className="header flex flex-col justify-center items-center">
          <p className="text-[15px] mt-3 text-gray-500">Enter OTP</p>
        </div>
        <div className=" mt-5 flex justify-center items-center">
          {[1, 2, 3, 4, 5, 6].map((i, index) => {
            return (
              <>
                <input
                  key={index}
                  ref={inputRefs[index]}
                  type="text"
                  maxLength={1}
                  className="w-[15px] otpinput xs:w-[35px] sm:w-[35px] md:w-[40px] text-bsblackrgb rounded-md bg-gray-300 h-8  mx-1 border-none focus:outline-none focus:border-none text-center"
                  value={pin[index]}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyUp={(e) => handleKeyUp(index, e)}
                />
              </>
            );
          })}
        </div>
        <Button
          loading={btnLoading}
          onClick={() => pin.length === 6 && handleVerify()}
          className={`SignInBtn w-full ${
            pin.length === 6 ? "cursor-pointer" : "cursor-not-allowed"
          }  mt-4 ${
            pin.length === 6 ? "bg-primary" : "bg-bsgray"
          }  flex justify-center border-none items-center h-12 mt-10 rounded-full text-white text-[12px] font-bold`}
        >
          <p>Verify OTP</p>
        </Button>
      </div>
    </Modal>
  );
};

export default VerifyModal;
